import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import StatusPill from './StatusPill';

const colorMap = {
	red: 'score.down',
	green: 'score.up',
	amber: 'score.warn',
	vdr: 'vdr.text',
};

const FieldRow = ({ label, value, valueColor, pill }) => {
	if (value === null || value === undefined || value === '') {
		return null;
	}

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				py: '3px',
			}}
		>
			<Typography
				sx={{
					fontSize: '12px',
					color: 'text.secondary',
				}}
			>
				{label}
			</Typography>

			{pill ? (
				<StatusPill label={value} color={pill.color} />
			) : (
				<Typography
					sx={{
						fontSize: '12px',
						fontWeight: 700,
						color: valueColor
							? colorMap[valueColor] || 'text.primary'
							: 'text.primary',
						textAlign: 'right',
						maxWidth: '60%',
					}}
				>
					{value}
				</Typography>
			)}
		</Box>
	);
};

FieldRow.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
    ]),
    valueColor: PropTypes.string,
    pill: PropTypes.shape({
        label: PropTypes.string,
        color: PropTypes.string,
    }),
};

export default FieldRow;
